import { render } from "./ProdutoRepeticaoAlteracaoInicio.vue?vue&type=template&id=627f5be9&scoped=true"
import script from "./ProdutoRepeticaoAlteracaoInicio.vue?vue&type=script&lang=js"
export * from "./ProdutoRepeticaoAlteracaoInicio.vue?vue&type=script&lang=js"

import "./ProdutoRepeticaoAlteracaoInicio.vue?vue&type=style&index=0&id=627f5be9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627f5be9"]])

export default __exports__